import { render, staticRenderFns } from "./KontextView.vue?vue&type=template&id=f8afd414&"
import script from "./KontextView.vue?vue&type=script&lang=ts&"
export * from "./KontextView.vue?vue&type=script&lang=ts&"
import style0 from "./KontextView.vue?vue&type=style&index=0&id=f8afd414&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports